/**
 * Base Filter class
 */
class Filter {
  constructor({
    searchParameter = '',
    options = null,
    updateCallback = null,
    searchParameters,
    selected,
  } = {}) {
    this.searchParameter = searchParameter;
    this.options = options;
    this.updateCallback = updateCallback;
    this.searchParameters = searchParameters;
    this.selected = selected;
  }
}

export default Filter;
